export interface Testimonial {
  quote: string
  name: string
  role: string
  image: string
}

export const testimonials: Testimonial[] = [
  {
    quote:
      'I don’t need another resource to read. I need to know where to start when the patient is in front of me.',
    name: 'Dr. Michael R.',
    role: 'Family Physician',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/2a8e5cc8-bde8-4ba3-bc48-ef11b7842384.jpg',
  },
  {
    quote:
      'Having the scenarios organized by decision pathway makes it much easier to navigate the information I already know I need.',
    name: 'Dr. Elena S.',
    role: 'Internal Medicine',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/c02182e1-934e-49ea-9e6a-cfb0b6e59cdb.jpg',
  },
  {
    quote:
      'The biggest difference is that I can start from the clinical problem instead of trying to remember where I saw the information.',
    name: 'Dr. James O.',
    role: 'Primary Care Physician',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/ec6af1da-1d4a-4bd5-8fb8-db303c743c9e.jpg',
  },
  {
    quote:
      'The checklists and decision cards are particularly useful when I need a quick reference during a busy consultation.',
    name: 'Dr. Amy L.',
    role: 'Internal Medicine',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/036a0e53-f835-47e1-bd67-8dd86f3cd370.jpg',
  },
]
